import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MacroDefinitionDto, MacroGroupDto } from 'webcommon/shared';
import { ApBaseComponent } from 'webcommon/core-ui';
import { MacroService } from '../ap-macro/index';
import { MacroInterfaces } from '../ap-macro/MacroInterfaces';
import { ApMacroEditorDetailsComponent } from './ap-macro-editor-details.component';

@Component({
  selector: 'ap-macro-editor',
  templateUrl: './ap-macro-editor.component.html',
})

export class ApMacroEditorComponent extends ApBaseComponent implements OnInit {
  @Input() baseId: string;
  @Input() macroService: MacroService;
  @Input() macroDefinitionDto: MacroDefinitionDto;
  @Input() macroInterfaces: MacroInterfaces;
  @Input() defaultMacroGroup: MacroGroupDto | null = null;
  @ViewChild('details', { static: true }) details: ApMacroEditorDetailsComponent;

  Id: string;

  constructor() {
    super();
    this.loading = false;
  }

  ngOnInit(): void {
    this.setId();
  }

  isAllInputValid() {
    const formValid = this.isFormValid();
    const inputValid: boolean = this.isInputValid();
    return formValid && inputValid;

  }

  private isFormValid() {
    return this.details.isFormValid();
  }

  private isInputValid(): boolean {
    return this.details.isInputValid();
  }

  private setId() {
    this.Id = `${this.baseId}-macro-editor`;
  }
}
